import React from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { Layout } from './components/Layout';
import { Home } from './pages/Home';
import { About } from './pages/About';
import { Solutions } from './pages/Solutions';
import { Resources } from './pages/Resources';
import { Contact } from './pages/Contact';
import { NotFound } from './pages/NotFound';
export function App() {
  return <BrowserRouter data-id="element-0" data-mp="2rkdwustqp9n8">
      <Routes data-id="element-1" data-mp="2rlynw8guiagc">
        <Route element={<Layout data-id="element-3" data-mp="2rit2b37fdqpd" />} data-id="element-2" data-mp="2rlf5yrr73m2b">
          <Route path="/" element={<Home data-id="element-5" data-mp="2mmlt91jqfz37" />} data-id="element-4" data-mp="2mluawsf5bxuv" />
          <Route path="/a-propos" element={<About data-id="element-7" data-mp="2mjpx9irg3khe" />} data-id="element-6" data-mp="2mn5b6i9dunh8" />
          <Route path="/solutions" element={<Solutions data-id="element-9" data-mp="31bs11dwmyxmp" />} data-id="element-8" data-mp="31agmqk5ke7hc" />
          <Route path="/ressources" element={<Resources data-id="element-11" data-mp="2wk0av4he6tx3" />} data-id="element-10" data-mp="31c1gw8nyvoeo" />
          <Route path="/contact" element={<Contact data-id="element-13" data-mp="2wifhhi6tdh0t" />} data-id="element-12" data-mp="2wjqg73lejyl2" />
          <Route path="*" element={<NotFound data-id="element-15" data-mp="28u5uwe1s0p8m" />} data-id="element-14" data-mp="2wi5nljineppu" />
        </Route>
      </Routes>
    </BrowserRouter>;
}